export const citiesSelector = state => state.cities.list;
export const selectedFleetSelector = state => state.cities.selectedFleet;
